import useCubit from "../blocs/hooks";
import { ProcessingService, ProcessingState } from "../blocs/processing-service/ProcessingService";

export default function FullScreenLoader() {
    const processingState = useCubit<ProcessingState>(ProcessingService.getInstance());
    if (processingState === 'PROCESSING') {
        return <div
        style={{
            zIndex: 99999,
            position: "fixed",
            height: "100vh",
            width: "100%",
            backgroundColor: "#ffffff26",
        }}
        >
        </div>
    }
    return <></>
}
